module.exports = __webpack_public_path__ + "static/media/map_md.38768842.png";